<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="headline primary--text">
          {{ $t('Tags Management') }}
        </div>
      </v-flex>
      <v-flex class="default-input">
        <v-text-field
          id="search"
          v-model="search"
          name="search"
          single-line
          :placeholder="$t('Search')"
          outline
          clearable
          prepend-inner-icon="search"
          hide-details
          @blur="onSearch"
          @keydown.enter="onSearch"
          @input="onSearch"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row justify-end class="mb-0">
      <v-btn class="mx-0" color="primary" @click="showModelCreateTag = true">สร้างป้ายกำกับ</v-btn>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mt-3"
      :pagination.sync="pagination"
      :loading="loading"
      :total-items="total"
    >
      <template #items="props">
        <tr>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-right">
            <v-btn fab small depressed @click="onDelete(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="showModelCreateTag"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn small flat fab @click="closeModelCreateTag()">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <h1 class="text-center">สร้างป้ายกำกับ</h1>
        <div style="padding: 20px">
          <div>ชื่อป้ายกำกับ</div>
          <div class="default-input">
            <v-text-field
              id="search"
              v-model="createTagName"
              name="search"
              single-line
              placeholder="ชื่อป้ายกำกับ"
              outline
              clearable
              hide-details
              @keydown.enter="handleCreateTag(createTagName)"
            ></v-text-field>
          </div>
        </div>
        <v-layout row justify-center>
          <v-btn outline :loading="loading" @click="closeModelCreateTag()">ยกเลิก</v-btn>
          <v-btn color="primary" :loading="loading" @click="handleCreateTag(createTagName)"
            >สร้าง</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import usersApi from '@/api/users'
import amazeApi from '@/api/amaze'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      search: '',
      items: [],
      pagination: { sortBy: 'name', descending: true, rowsPerPage: 25 },
      loading: true,
      total: 0,
      updateSearchTimeout: null,
      showModelCreateTag: false,
      createTagName: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    headers() {
      return [
        {
          value: 'name',
          text: this.$t('Name'),
          align: 'center',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ]
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          const { result, total } = await this.getUserTagList()
          this.items = result
          this.total = total
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    }
  },

  methods: {
    closeModelCreateTag() {
      this.showModelCreateTag = false
      this.createTagName = ''
    },
    async handleCreateTag(tagName) {
      try {
        this.loading = true

        const body = {
          page_id: this.selectedBot.pageid
        }

        Object.assign(body, { user_tag_data: [tagName] })
        await usersApi.postCreateTag(body)

        this.closeModelCreateTag()
        const { result, total } = await this.getUserTagList()
        this.items = result
        this.total = total
      } catch (error) {
        this.$swal.fire({
          text: 'สร้าง tag ไม่สำเร็จ',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      const vm = this
      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }
      if (this.loading) return false
      vm.updateSearchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          const { result, total } = await vm.getUserTagList()
          vm.items = result
          vm.total = total
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.updateSearchTimeout = null
      }, 3000)
    },
    async getUserTagList() {
      const { page, rowsPerPage } = this.pagination
      let offset = (page - 1) * rowsPerPage,
        limit = page * rowsPerPage
      if (rowsPerPage == -1) {
        limit = 999999
        offset = 0
      }
      var response = await api.getUserTagList({
        offset,
        limit,
        filter_name: this.search || undefined
      })
      if (response && response.result) {
        return { result: response.result, total: response.total_count || 0 }
      } else {
        return { result: [], total: 0 }
      }
    },
    async onDelete(id) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        let index = this.items.findIndex((el) => el.id == id)
        if (index != -1) {
          let response = await api.deleteUserTagList({
            body: {
              id: id,
              tag: this.items[index].name
            }
          })
          if (response.success) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.items.splice(index, 1)
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('Error')
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/tag/TagsManagement.vue